import React from 'react';

const NumberInput = ({ question, value, onChange, error }) => {
  const handleChange = (e) => {
    const val = e.target.value;
    // Ensure 2 digit max for age
    if (val.length <= 2) {
      onChange(val);
    }
  };

  return (
    <div className="question-input">
      <input
        type="number"
        value={value || ''}
        onChange={handleChange}
        placeholder={question.placeholder}
        min={question.min || 1}
        max={question.max || 99}
        className={`quiz-input ${error ? 'error' : ''}`}
        required={question.required}
      />
      {error && <span className="error-message">{error}</span>}
    </div>
  );
};

export default NumberInput;